<style lang="less">
    @import "../../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="table-list" style="margin-top:25px">
            <div class="table-list-title">
                <span style="margin-left:25px">权利人管理</span>
                <button class="btn-84" @click="jumpPage" data-url="/addObligee" style="float:right;margin-right:30px">
                    增加权利人
                </button>
            </div>
            <Row class="table-style-size">
                <i-col span="8">权利人名称</i-col>
                <i-col span="6">权利人地址</i-col>
                <i-col span="5">证件有效期</i-col>
                <i-col span="5">操作</i-col>
            </Row>

            <errorTips style="padding-top: 75px" :state="0" v-if="loadFlag && records.length == 0"></errorTips>
            <div v-else>
                <Row v-for="(item,index) in records" class="table-style-size table-style-body" style="height:65px">
                    <i-col span="8">{{ item.name }}
                    </i-col>
                    <i-col span="6">
                        <Tooltip style="max-width: 100%;" max-width="177" :content="item.address && item.address!='null' ? item.address : ''"><p
                                class="partial_result_url">{{ item.address && item.address!='null' ?  item.address : '' }}</p></Tooltip>
                    </i-col>
                    <i-col span="5">{{ item.attachEndTime }}</i-col>
                    <i-col span="5" class="notwrap">
                        <span v-if="item.obligeeRealNameStatus == 'complete_real_name' ">实名成功</span>
                        <span v-else-if="item.obligeeRealNameStatus == 'wait_approve' ">审核中</span>
                        <router-link v-else-if="item.obligeeRealNameStatus == 'reject_real_name'"
                                     style="display: inline-block;" class="btn-84"
                                     :to="item.obligeeType == 'enterprise' ? '/enterpriseAuthentication1?id=' + item.id : '/personalAuthentication?id=' + item.id ">
                            修改
                        </router-link>
                    </i-col>
                </Row>

                <div class="commont-page" style="position: absolute;bottom: 10px;left: 50%;transform: translate(-50%, -50%);">
                    <Page @on-change="changepage" :total="total" size="small" :page-size="pageSize" show-total
                          show-elevator
                          class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {_getByPage} from "@/api/obligee.js";
    import errorTips from '@/views/main-components/error-tips';
    import Cookies from "js-cookie";
    import {_findMainObligee} from "@/api/authentication.js";

    export default {
        metaInfo: {
            title: '权利人管理|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '权利人管理,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'walletPay',
        data() {
            return {
                pageNumber: 1,
                pageSize:8,
                total: 0,
                pages: 1,
                records: [],
                loadFlag:false, //加载flag
                hasMainObligee: true,
            }
        },
        components: {
            errorTips
        },
        mounted() {
            this.getByPage();
        },
        methods: {
            getByPage() {
                let userInfo = JSON.parse(Cookies.get("userInfo"));
                const data = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    registerId: userInfo.id,
                    sort: 'createDate',
                    order: 'desc'
                };
                _getByPage(data).then(res => {
                    if (res.code == 200) {
                        var result = res.result;
                        this.total = result.total - 0;
                        this.pages = result.pages;
                        this.records = result.records;
                        this.loadFlag = true;
                    }
                });
            },

            changepage(index) {
                this.pageNumber = index;
                this.getByPage()
            },

            jumpPage(data) {
              this.findMainObligee().then(() => {
                if (this.hasMainObligee === false) {
                  this.$router.push('/authentication')
                } else {
                  const url = data.target.dataset.url;
                  this.$router.push({path: url})
                }
              })
            },
          findMainObligee() {
            // 外层返回 Promise，供 jumpPage 等待
            return new Promise((resolve) => {
              _findMainObligee().then(res => {
                if (res.code == 200) {
                  let result = res.result;
                  let submitType = result.obligeeType;
                  this.poId = result.id;
                  this.name = result.name;
                  this.submitType = submitType;
                  this.auditStatus = result.obligeeRealNameStatus;
                  this.identityNumber = result.identityNumber;
                  this.enterpriseDuration = result.attachStartTime + '至' + result.attachEndTime;
                  this.enterpriseAddress = result.address && result.address != 'null' ? result.address : '';
                  this.remarks = result.remarks ? result.remarks : ''
                  this.attachExpired = result.attachExpired

                  // 存在主体，标记为 true
                  this.hasMainObligee = true;

                  // 企业
                  if (submitType == 'enterprise') {
                    this.photoArr = [];
                    this.photoArr.push(result.attachment3Url);
                    this.licensePhoto = result.attachment3Url;
                    this.licenseStatus = 0
                  }
                  // 个人
                  else {
                    this.photoArr = [];
                    this.photoArr.push(result.attachment1Url, result.attachment2Url);
                    this.frontalPhoto = result.attachment1Url
                    this.reversePhoto = result.attachment2Url
                    this.frontalState = 0
                    this.reverseState = 0
                  }
                } else if (res.code == 201) {
                  this.hasMainObligee = false;
                } else {
                  toast('获取失败，请刷新后重试');
                }
                // 异步逻辑执行完成，放行
                resolve();
              }, (err) => {
                toast('获取失败，请刷新后重试');
                // 异常也必须 resolve，否则页面点击无响应
                resolve();
              });
            })
          }
        }
    }
</script>
<style scoped lang="less">
    .partial_result_url {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .center-table-list .table-list {
        width: 1108px;
    }
</style>
